// const env = 'development' // 开发环境
// const env = 'test' // 测试环境
const env = 'production' // 生产环境

let baseURL = '' // 接口地址
let imgURL = '' // 接口地址


switch (env) {
  case 'development': // 开发环境
    baseURL = 'http://192.168.0.119:9998'
    imgURL = 'http://192.168.0.145:8083'
    break
  case 'test': // 测试环境
    baseURL = 'http://192.168.0.145:9998'
    imgURL = 'http://192.168.0.145:8083'
    break
  case 'production': // 生产环境
    // baseURL = 'https://api.singmap.com'
    baseURL = 'https://api.singmap.com'
    // imgURL = 'https://img.singmap.com'
    imgURL = 'https://img.singmap.com'
    break
}

export { baseURL, imgURL }



// WEBPACK FOOTER //
// ./src/config/evn.js